import { render, staticRenderFns } from "./trocar-assinatura.vue?vue&type=template&id=3bc0ef73"
import script from "./trocar-assinatura.vue?vue&type=script&lang=js"
export * from "./trocar-assinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports